import React from 'react';
import { InternalLink, routes } from 'gatsby-theme-apollo';
import styled from '@emotion/styled';
import removeMd from 'remove-markdown';
import { Card, Cards, CardTitle, CardTimeStamp } from './cards';
import { LimitReducer } from '../limit/limiter';
import useLimitedSet from '../../hooks/use-limit';

const UpdatePreview = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 200px;
  min-height: 80px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.8);
`;

const UpdatePreviewText = styled.div`
  padding: 10px;
  text-align: left;
`;

const ReadMore = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding-bottom: 5px;
  padding-top: 15px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  margin: 0px auto;
  background: linear-gradient(to top, #111, 80%, transparent);
  border-bottom: 1px solid ${props => props.theme.divider};
`;

const Img = styled.img`
  width: 100%;
  height: 200px;
`;

const previewCharacters = 200;

const PatchPreviewCards = ({
  patchPreviews,
  limit,
  showInterval = 12,
  showGameName,
  disableShowMore
}) => {
  const [patchPreviewsToDisplay, currentLimit, increaseLimit] = useLimitedSet({
    initialLimit: limit,
    set: patchPreviews,
    interval: showInterval
  });

  return (
    <>
      <Cards>
        {patchPreviewsToDisplay &&
          patchPreviewsToDisplay.map(patchPreview => {
            return <PatchPreviewCard patchPreview={patchPreview} showGameName={showGameName} key={patchPreview.game+patchPreview.version} />;
          })}
      </Cards>
      {!disableShowMore && (
        <LimitReducer
          limit={currentLimit}
          setSize={patchPreviews && patchPreviews.length}
          onIncreaseLimit={increaseLimit}
          showInterval={showInterval}
        />
      )}
    </>
  );
};

const PatchPreviewCard = ({ patchPreview }) => {
  const { version, createdAt, description, heroImage, game } = patchPreview;
  const { name: gameName } = game;

  const previewMarkdownRemoved = removeMd(description, { stripListLeaders: false });
  const previewText = previewMarkdownRemoved.substring(0, previewCharacters);

  return (
    <Card style={{ padding: `0px`, margin: `10px`, maxWidth: `500px` }}>
      <InternalLink
        style={{ padding: `0px`, color: `inherit` }}
        to={routes.Patch(gameName, version)}
      >
        {heroImage && <Img src={heroImage.url} />}

        <CardTitle>{`${gameName} | ${version}`}</CardTitle>
        <UpdatePreview>
          {previewText && <UpdatePreviewText>{previewText}</UpdatePreviewText>}
          <ReadMore>
            <h4>Full Patch Notes</h4>
          </ReadMore>
        </UpdatePreview>
        <CardTimeStamp createdAt={createdAt} />
      </InternalLink>
    </Card>
  );
};

export default PatchPreviewCards;
